/* Maison Mata — bon cadeau (refonte des pages produits, oct. 2026). Chargé en plus de mm-pp.js.
   1. « Amount » : le prix de chaque variante s'affiche dans son bouton. Le sélecteur de variantes reste celui
      de Dawn (même choix, même prix, même ajout au panier) : on ajoute seulement le prix dans chaque bouton,
      à partir des prix rendus par Shopify dans le bloc caché [data-mm-gift-amts] (convertis par l'app de devises).
   2. Barre fixe « Add to cart » (mobile) : le prix suit la variante choisie. */
(function () {
  'use strict';

  function clean(t) { return (t || '').replace(/\s+/g, ' ').trim(); }

  function decorate(root) {
    var store = document.querySelector('[data-mm-gift-amts]');
    if (!store || !root) return;
    var lists = root.matches && root.matches('variant-selects') ? [root] : root.querySelectorAll('variant-selects');
    Array.prototype.forEach.call(lists, function (vs) {
      vs.querySelectorAll('input[type="radio"][data-option-value-id]').forEach(function (input) {
        var label = input.nextElementSibling;
        if (!label || label.tagName !== 'LABEL') return;
        var src = store.querySelector('[data-ov="' + input.getAttribute('data-option-value-id') + '"]');
        if (!src) return;
        var txt = clean(src.textContent);
        if (!txt) return;
        var tgt = label.querySelector('.mm-gift-amt');
        if (!tgt) {
          tgt = document.createElement('span');
          tgt.className = 'mm-gift-amt';
          label.appendChild(tgt);
        }
        if (tgt.textContent !== txt) tgt.textContent = txt;
      });
    });
  }

  function syncSticky() {
    var p = document.querySelector('.mm-pp-sticky__p');
    if (!p) return;
    var el = document.querySelector('.product__info-container .price__regular .price-item--regular') ||
             document.querySelector('.product__info-container .price-item');
    var t = el ? clean(el.textContent) : '';
    if (t && p.textContent !== t) p.textContent = t;
  }

  function sync() { decorate(document); syncSticky(); }

  function init() {
    sync();
    document.querySelectorAll('product-info').forEach(function (pi) {
      /* prix ajoutés au nouveau sélecteur avant son affichage (changement de variante) */
      if (typeof pi.addPreProcessCallback === 'function') {
        pi.addPreProcessCallback(function (html) { try { decorate(html); } catch (e) {} });
      }
      if ('MutationObserver' in window) {
        new MutationObserver(sync).observe(pi, { childList: true, subtree: true, characterData: true });
      }
    });
    /* la barre fixe est créée par mm-pp.js ; l'app de devises convertit les prix après le chargement */
    window.addEventListener('load', sync);
    setTimeout(sync, 1500);
    setTimeout(sync, 4000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
